import { ca } from '@cian/analytics';
import { getAnalyticsSiteType } from '../utils/analytics';
import { EWidgetMode } from '../types/redux/layout';
import { EPaymentInitSource } from '../types/redux/checkout';
import { TPackageId } from '../types/api';

interface IParams {
  paymentInitSource: EPaymentInitSource;
  mode: EWidgetMode;
  packageId?: TPackageId;
}

export const trackPaymentWidgetShow = (params: IParams) => {
  const { paymentInitSource, mode, packageId } = params;

  const action = mode === EWidgetMode.Payment ? 'Open_widget_buy' : 'Open_widget_refill';

  ca('eventSite', {
    name: 'oldevent',
    category: paymentInitSource,
    action,
    label: 'popup_payment_options',
    page: {
      siteType: getAnalyticsSiteType(),
      extra: {
        package_info: { id: packageId },
      },
    },
  });
};
